import { Component, OnInit, OnChanges, Input, Output, EventEmitter, OnDestroy, ViewEncapsulation, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { Entry } from 'contentful';

import { ContentService } from '@src/app/shared/services/content.service';
import { paginateState } from '@src/app/shared/animations/animations';

import { EntryData } from '@src/app/shared/interfaces/entryData';

@Component({
  selector: 'app-blog-entries',
  templateUrl: './blog-entries.component.html',
  styleUrls: ['./blog-entries.component.scss'],
	animations: [
		paginateState
	],
	encapsulation: ViewEncapsulation.None
})

export class BlogEntriesComponent implements OnInit, OnChanges, OnDestroy {
	@Input() entries: Entry<any>[];
	@Output() openEntry = new EventEmitter<EntryData>();

	entry: Entry<any> | null;
	entrySub: Subscription;
	featuredEntries: Entry<any>[];
	pagedEntries: Entry<any>[];
	entryCounter: number = 0;

	featuredCount: number = 5;
	entPerPage: number = 4;
	pages: Array<number>;
	activePage: number;

	constructor(private contentService: ContentService) {}

	getFeatured(): void {
		this.featuredEntries = this.entries.slice(
			0, this.featuredCount
		);
	}

	getPaged(page?: number, $event?: Event): void {
		this.getFeatured();
		
		this.pagedEntries = this.entries.filter(
			e => !this.featuredEntries.includes(e)
		).slice(
			((page - 1) * this.entPerPage) || 0, 
			(page * this.entPerPage) || this.entPerPage
		);

		if (page)
			this.activePage = page;
	} 
	
	resultsMsg(): string {
		return `Showing ${this.entries.length} result${this.entries.length !== 1 ? 's' : ''}`
	}

  open(e: Entry<any>) { this.openEntry.emit({ entry: e, entries: this.entries }); }

	addClass(i: number): string {
		if (i + 1 <= this.featuredCount) {
			if (i === 0) {
				return ' full'
			} else {
				return ' half'
			}
		} else {
			return ''
		}
	}

	// Lifecycle Hooks

	ngOnInit(): void {
		this.entrySub = this.contentService.entry.subscribe(
			data => this.entry = data
		);

		this.activePage = 1;
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.entries) {
			const getValues = (arr: any[] | undefined): any => {
				if (arr === undefined)
					return undefined;

				const newArr = [];
				arr.forEach(e => {newArr.push(e.sys.id)})
				return newArr;
			};

			const prev = getValues(changes.entries.previousValue);
			const curr = getValues(changes.entries.currentValue);

			if (
				!curr.length ||
				prev.length !== curr.length ||
				!prev.every((e, i) => e === curr[i])
			) {
				this.getFeatured();
				this.getPaged();

				this.pages = Array.from(
					Array(Math.ceil(
						(this.entries.length - this.featuredEntries.length) / this.entPerPage
					)).keys()
				).map(
					e => e + 1
				);
			}

			if (prev?.length !== curr?.length) {
				this.activePage = 1;
			}
		}
	}

	ngOnDestroy(): void {
		this.entrySub.unsubscribe();
	}
}
